export default __webpack_public_path__ + "static/ordering_placeholder-112769cfffccd6678a7e0417cb78a967.png";